import { useState } from 'react';
import PortalIdParser from 'PortalIdParser';
import { refreshCookie } from 'hub-http/auth';
import { startTrial } from 'purchase-motions-api/mutation/startTrial';
import { clearNavigationCache } from 'purchase-motions-api/query/navigation';
import Raven from 'raven-js';
import { apiNameToTrialIds } from '../constants/trial';
export const useStartTrial = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const mutate = async ({
    apiName,
    source,
    onSuccess
  }) => {
    const trialId = apiNameToTrialIds[apiName];
    if (!trialId) {
      const e = new Error('Missing trialId for trial activation');
      Raven.captureException(e);
      setError(e);
      return;
    }

    // Remove Zorse ISC chat eligibility cache, so users get the right version of the Zorse widget immediately upon trial activation
    try {
      localStorage.removeItem('hubspot:isc:userIsEligibleForIscChat');
    } catch (e) {
      // Noop
    }
    setLoading(true);
    try {
      const createdTrial = await startTrial({
        trialId: [trialId],
        trialSource: source
      });
      setData(createdTrial);
      onSuccess === null || onSuccess === void 0 || onSuccess();
      await new Promise(resolve => setTimeout(resolve, 3000)); // Timeout for 3 secs to allow parcels to provision before invalidating cache/refreshing cookie. This is a stopgap until Mon BE can modify the trial activation endpoint to wait to return success until the scopes are properly provisioned. Once that change is made, we can remove the timeout logic from here
      void clearNavigationCache(); // Reset the nav cache so users can see updated nav options immediately
      void refreshCookie(PortalIdParser.get(), true); // Refresh cookie so /login-verify/hub-user-info starts returning new scopes immediately
      return createdTrial;
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  };
  return [mutate, {
    data,
    error,
    loading
  }];
};